import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=7afa1e27&scoped=true"
import script from "./notice.vue?vue&type=script&lang=js"
export * from "./notice.vue?vue&type=script&lang=js"
import style0 from "./notice.vue?vue&type=style&index=0&id=7afa1e27&prod&lang=css"
import style1 from "./notice.vue?vue&type=style&index=1&id=7afa1e27&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afa1e27",
  null
  
)

export default component.exports